import React from "react";

import ListItemText from "@material-ui/core/ListItemText";
import * as styles from "../newStyles.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { css } from "react-emotion";
// import Flickity from "react-flickity-component";

const gridStyle = css`
  margin-top: 30px;
  width: 100%;
  outline: none;
  display: -ms-grid;
  display: grid;
  grid-gap: 25px;
  -ms-grid-columns: 100%;
  grid-template-columns: 100%;
  @media (min-width: 31.3125em) {
    -ms-grid-columns: (calc(50% - 12.5px));
    grid-template-columns: repeat(2, calc(50% - 12.5px));
  }
  @media (min-width: 48.0625em) {
    -ms-grid-columns: (calc(25% - 30px));
    grid-template-columns: repeat(4, calc(25% - 30px));
    grid-gap: 40px;
  }
`;

const flickityStyle = css`
  height: 171px;
  touch-action: pan-y;
`;
const slider = css`
  left: 0px;
`;
const flickityContainer = css`
  position: absolute;
  left: 0%;

  @media (max-width: 31.3025em) {
    width: 65%;
    padding: 0 5%;
    margin: 0 auto;
    cursor: move;
    cursor: grab;
    cursor: -webkit-grab;
  }
`;

const listItemStyle = css`
  text-align: center;
  -webkit-column-break-inside: avoid;
  -moz-column-break-inside: avoid;
  break-inside: avoid;
`;

const listItemSmall = css`
  @media (max-width: 48.0525em) {
    max-width: 420px;
    margin: auto;
  }
`;

const icon = css`
  font-size: 36px;
  width: auto;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
  color: #89d2d3;
`;

const currentFeatures = [
  {
    title: "24/7 Human Customer Support",
    icon: "bell",
  },

  {
    title: "Video Tutorials",
    icon: "business-time",
  },
  {
    title: "Credit card processing",
    icon: "hand-holding-usd",
  },
  {
    title: "Discounted Shipping Integration",
    icon: "shopping-basket",
  },
  {
    title: "Insurance",
    icon: "star",
  },
  {
    title: "Business Coaching",
    icon: "chart-line",
  },
  {
    title: "Year end tax papers",
    icon: "handshake",
  },
  {
    title: "Customer management software",
    icon: "wifi",
  },
];

export default function SupportFeatures(props) {
  const { noTitle } = props;
  const renderFeatures = () => {
    return (
      <div style={{ margin: "auto" }}>
        <div className={gridStyle}>
          {currentFeatures.map((feature) => {
            return (
              <div
                className={listItemStyle + " " + listItemSmall}
                key={feature.title}
              >
                <FontAwesomeIcon icon={feature.icon} className={icon} />

                <h2 className={styles.innerH2} style={{ textAlign: "center" }}>
                  {feature.title}
                </h2>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.row}>
      <div
        style={{
          maxWidth: "1000px",
          margin: "auto",
          display: "flex",
          flexFlow: "row wrap",
        }}
      >
        <styles.H2
          style={{
            textAlign: "center",
            margin: "30px",
            width: "100%",
            marginTop: noTitle ? "0px" : "60px",
          }}
        >
          We’re Here for <span className={styles.styledUnderline}>You</span>
        </styles.H2>

        <styles.P
          style={{
            margin: "auto",
            lineHeight: "1.875",
            textAlign: "center",
          }}
        >
          We know how challenging it is to run a small business. We aim to be
          your one stop shop for all things business and provide you any support
          you need.
        </styles.P>

        {renderFeatures()}
      </div>
    </div>
  );
}
